// Terra slab colouring, shared by the deck hero (1920px slides) and the ROI summary (page scale).
// A slab is a solid colour block (no gradient, no glow): the `.slab` class in styles.css gives the
// giant radius and inset highlight, and this gives the fill and the ink from the family's 500 shade.
// Pure style data, so the deck can import it without touching the engine.

import type { CSSProperties } from 'react';

export type SlabFamily = 'lime' | 'lemon' | 'slushie' | 'ube' | 'tangerine' | 'blueberry' | 'oat';

export const slabStyle = (family: SlabFamily, level: 100 | 200 | 300, extra: CSSProperties = {}): CSSProperties => ({
  background: `var(--${family}-${level})`,
  color: `var(--${family}-500)`,
  ...extra,
});
